export const MaskUtils = {
  DECIMAL_SEPARATOR : '.',
  GROUP_SEPARATOR : ',',

  formatCep: (valString) => {
    if (!valString) {
      return '';
    }
    const val = valString.toString();
    const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR);
    if (parts[0].length > 8) {
      const teste = parts[0].substring(0, 8);
      parts[0] = teste;
    }
    this.maskedId = this.cep_mask(parts[0]);
    return this.maskedId;
  },

  formatCpfCnpj:(valString)=> {
    if (!valString) {
      return '';
    }
    const val = valString.toString();
    const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR);
    if (parts[0].length > 11) {
      const teste = parts[0].substring(0, 14);
      parts[0] = teste;
      this.maskedId = this.cnpj(parts[0]);
    } else {
      const teste = parts[0].substring(0, 11);
      parts[0] = teste;
      this.maskedId = this.cpf_mask(parts[0]);
    }
    return this.maskedId;
  },

  unmaskMoney(value) {
   
    return (
      parseInt(
        (value + "")
          .replace(/R\$/gi, "")
          .replace(/\s/gi, "")
          .replace(/\./gi, "")
          .replace(/,/gi, "")
      ) / 100
    );
  },

  unFormat:(val) => {
    if (!val) {
      return '';
    }
    val = val.replace(/\D/g, '');
    val =val.replace(/,/g, '') ;
    val =val.replace(/\./g, '')
    return val;
  }
}